<div class="flex flex-col gap-4 md:gap-6 rounded-md bg-shui-base-3 p-4 md:p-6 max-w-[900px]">
    <div class="flex flex-col gap-1 mb-2 md:mb-4">
        <h2 class="text-base md:text-lg font-semibold text-shui-text-strong p-0 m-0">
            {{ 'common.settings.application.title' | translate }}
        </h2>
        <p class="text-xs md:text-sm text-shui-text-subtle p-0 m-0">
            {{ 'common.settings.application.subtitle' | translate }}
        </p>
    </div>

    <div class="flex flex-col gap-6">
        <!-- Umgebungshinweis anzeigen -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
            <div class="flex flex-col gap-1">
                <span class="text-sm font-medium text-shui-text-strong">{{
                    'common.settings.application.show-environment-hint.title' | translate
                }}</span>
                <span class="text-xs text-shui-text-subtle">{{
                    'common.settings.application.show-environment-hint.description' | translate
                }}</span>
            </div>
            <sh-toggle
                data-testid="toggle-environment-hint"
                [attr.active]="showEnvironmentHint() ? true : null"
                (click)="environmentHintChange.emit()"
            ></sh-toggle>
        </div>
    </div>
</div>
